import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/services/alert.service';



@Component({
  selector: 'app-productpopup',
  templateUrl: './productpopup.component.html',
  styleUrls: ['./productpopup.component.scss']
})
export class ProductpopupComponent implements OnInit {
  showNotes: boolean = true;
  form: any;
  id: any;

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private _location: Location,
    private alertService: AlertService,


    public dialogRef: MatDialogRef<ProductpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,

      public addServiceDialog: MatDialog,
      private navigationService: NavigationService,
  ) { this.id = this.dataRecievedToEdit.id}

  ngOnInit(): void {

    this.showNotes = true;
this.initializeValidators();
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      remarks: ['',Validators.required]
    })
  }
  
  next(isProceed){
    this.dialogRef.close(isProceed);

  }

  goToAction(item: number){
    if(this.form.valid){
  var data = {
    id: this.id,
    approvedStatusType: item,
    remarks: this.form.value.remarks,
    financialYearId:this.dataRecievedToEdit.financialYearId

  }
    this.productService.productApprove(data).subscribe(result => {
      if (result) {
      this.alertService.success('Product Rejected Successfully');
          this._location.back();
        }           
      });
    }
    else {
      this.validateFormControl();
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
}

